
export const parseJSON = (data: string | undefined): string[] => {
  try {
    return data ? JSON.parse(data) : [];
  } catch {
    return [];
  }
};

export const normalizeQualificationKey = (key?: string): string | undefined => {
  if (!key) return undefined;
  const map: Record<string, string> = {
    currently_studying: "I_AM_CURRENTLY_STUDYING",
    no_qualifications: "I_HAVE_NO_QUALIFICATION",
  };
  return map[key.toLowerCase()] ?? key.toUpperCase();
};

export const getEnumValue = (enumObj: any, key: string | undefined): string => {
  if (!key) return "-";
  return enumObj?.[key.toUpperCase()] ?? key;
};

export const getFormatedDate = (
  date: string,
  dayFormat: string = "numeric",
  monthFormat: string = "short",
  yearFormat: string = "numeric"
) => {
  if (!date) return "Invalid Date";
  const formattedDate = new Date(date).toLocaleDateString("en-GB", {
    day: "numeric",
    month: "short",
    year: "numeric",
  });
  return formattedDate.replace(/ /g, " ");
};

export const downloadFile = (url: string, fileName: string) => {
  const link = document.createElement("a");
  link.href = url;
  link.setAttribute("download", fileName);
  link.target = "_blank";
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
};


// Add this utility function at the top or in a utils file
export const convertTo12Hour = (time24: string): string => {
  if (!time24) return "";
  const [hourStr, minute, second] = time24.split(":");
  let hour = parseInt(hourStr, 10);
  const ampm = hour >= 12 ? "pm" : "am";
  hour = hour % 12 || 12;
  return `${hour.toString().padStart(2, "0")}:${minute}${ampm}`;
};

// Function to format date and time for events
// Example usage: formatEventDateTime("01 Jun 2025", "09:00", "20:00")
// Expected output: "Wed 4 Jun 2025, 10:15am to 7:45pm"
export const formatEventDateTime = (
  dateStr: string,
  startTime: string,
  endTime: string
): string => {
  // Parse date
  if(dateStr === "" && startTime === "" && endTime === "") {
    return "";
  }
  const [day, month, year] = dateStr.split(" ");
  const dateObj = new Date(`${day} ${month} ${year}`);
  const weekday = dateObj.toLocaleDateString("en-GB", { weekday: "short", timeZone: "UTC" });
  const dayNum = dateObj.getDate();
  const monthShort = dateObj.toLocaleDateString("en-GB", { month: "short", timeZone: "UTC" });
  const yearNum = dateObj.getFullYear();

  // Convert times
  const start12 = convertTo12Hour(startTime);
  const end12 = convertTo12Hour(endTime);

  return `${weekday} ${dayNum} ${monthShort} ${yearNum}, ${start12} to ${end12}`;
};

export const getTimeZoneInfo = () => {
    // Define the current date
    const now: Date = new Date();

    // Define the options for the formatter
    const options: Intl.DateTimeFormatOptions = {
      timeZoneName: "long",
      timeZone: "Australia/Sydney", // AEDT timezone
    };

    // Create a formatter with the specified options
    const formatter: Intl.DateTimeFormat = new Intl.DateTimeFormat(
      "en-US",
      options
    );

    // Extract formatted timezone details
    const parts: Intl.DateTimeFormatPart[] = formatter.formatToParts(now);

    // Find the part that contains the time zone name
    const timeZoneName: string | undefined = parts.find(
      (part) => part.type === "timeZoneName"
    )?.value;

    // Calculate the offset in hours
    const offsetMinutes: number = -now.getTimezoneOffset();
    const offsetHours: number = offsetMinutes / 60;

    const timeZone: string = `AEDT (${timeZoneName}) UTC/GMT ${
      offsetHours >= 0 ? "+" : ""
    }${offsetHours} hours`;
    // Log the timezone information
    return timeZone;
  };

export const getStageName = (stageNumber: number): string => {
  const stageMap: Record<number, string> = {
    1: "Personal Details & Interview",
    2: "Compliance Checks",
    3: "Documents & Contract",
  };

  const stageLabel = stageMap[stageNumber];
  return stageLabel ? `Stage ${stageNumber}: ${stageLabel}` : "Unknown Stage";
};